/** @format */

export const POST_TRACKING_NUMBER = 'POST_TRACKING_NUMBER'
export const POST_TRACKING_NUMBER_SUCCESS = 'POST_TRACKING_NUMBER_SUCCESS'
export const POST_TRACKING_NUMBER_ERROR = 'POST_TRACKING_NUMBER_ERROR'
